var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTbank(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 128 128",
    enableBackground: "new 0 0 128 128",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M96.2,57.1c-2.1-1.4-4.4-2.5-6.7-3.3c-8-2.8-10.1-2.1-14.3,5.4c-3.1,5.5-5.8,11.1-8.9,16.6 c-1.3,2.4-2.8,4.8-4.8,6.7C51.1,92.8,38,94.6,24.1,93.7c4.2-2.4,7-6,9.4-10.1c3.1-5.4,6.2-10.9,9.1-16.5c3.2-6.1,7.7-10.8,14-13.7 c1.1-0.5,2.1-0.9,3.2-1.3c-0.1-0.1-0.1-0.2-0.2-0.3c-0.3,0-0.6,0-0.9,0C43.6,54,29.4,58.6,16.6,67.1c-5.6,3.6-10.5,8-14,13.8 c-4.9,8.2-2.7,16.5,5.8,20.8c2.9,1.5,6.1,2.6,9.2,3.4c10.1,2.4,20.3,1.8,30.4,0c14-2.5,27.3-7.2,39.1-15.3 c5.6-3.8,10.7-8.3,13.8-14.6C104.4,68.3,102.7,61.5,96.2,57.1z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    fill: "#FFFFFF",
    enableBackground: "new    ",
    d: "M124.8,21.4c-21.1,0-42.3-0.1-63.4,0.1 c-5.9,0-11.9,0.5-17.8,1.4c-9.5,1.4-18.4,4.8-25.7,11.3c-3.7,3.2-6.6,7.1-8.4,12c1.1,0.1,1.8,0.2,2.6,0.2c22.9,0,45.9,0.1,68.8-0.1 c10.5-0.1,20.8-2,30.2-6.9c7.6-3.9,13.3-9.5,17-18C126.6,21.4,125.7,21.4,124.8,21.4z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTbank);
export default __webpack_public_path__ + "static/media/tbank.06756daadae14dd8b0549e2421457052.svg";
export { ForwardRef as ReactComponent };